module.exports = __webpack_public_path__ + "static/media/paypal.fa90774c.svg";